<template>
    <div>
        <c-product-single-tabs class="product-single-tabs">
            <c-nav-tabs>
                <ul
                    class="nav nav-tabs"
                    role="tablist"
                    aria-owns="product-tab-desc product-tab-reviews"
                >
                    <li
                        class="nav-item"
                        role="tab"
                        id="product-tab-desc"
                        aria-controls="product-desc-content"
                        aria-selected="true"
                    >
                        <a
                            class="nav-link active color-nav-link"
                            data-toggle="tab"
                            href="#product-desc-content"
                        >
                            Descrição
                        </a>
                    </li>
                    <li
                        v-if="showRatings"
                        class="nav-item"
                        id="product-tab-reviews"
                        role="tab"
                        aria-controls="product-reviews-content"
                        aria-selected="false"
                    >
                        <a
                            class="nav-link color-nav-link"
                            data-toggle="tab"
                            href="#product-reviews-content"
                        >
                            Comentários
                        </a>
                    </li>
                </ul>
            </c-nav-tabs>
            <c-tab-content class="tab-content">
                <div
                    class="tab-pane show active"
                    id="product-desc-content"
                    role="tabpanel"
                    aria-labelledby="product-tab-desc"
                >
                    <div
                        v-if="item.pro_description"
                        class="product-desc-content"
                        v-html="item.pro_description"
                        style="max-width: 800px"
                    ></div>
                    <div
                        v-else
                        class="product-desc-content"
                        id="no-description-product"
                        style="max-width: 800px"
                    >
                        Nenhuma descrição para este produto
                    </div>
                </div>
                <div
                    v-if="showRatings"
                    class="tab-pane fade"
                    id="product-reviews-content"
                    role="tabpanel"
                    aria-labelledby="product-tab-reviews"
                >
                    <div
                        class="product-reviews-content"
                        style="max-width: 800px"
                    >
                        <ReviewForm :item="item" />
                    </div>
                </div>
            </c-tab-content>
        </c-product-single-tabs>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
    CProductSingleTabs,
    CNavTabs,
    CTabContent
} from "../../components/Styles/Tab/styled";
import ReviewForm from "./ReviewForm.vue";

export default {
    name: "ProductTabContent",
    components: {
        ReviewForm,
        "c-product-single-tabs": CProductSingleTabs,
        "c-nav-tabs": CNavTabs,
        "c-tab-content": CTabContent
    },
    computed: {
        ...mapState("products", ["item"]),
        ...mapGetters("company", ["showRatings"])
    }
};
</script>
